import { render } from "./Wheel8.vue?vue&type=template&id=5c2ec0d2"
const script = {}
script.render = render

export default script